import React, { useEffect, useRef, useState } from 'react';
import './styles/PdfViewer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';

function useCacheFile(url) {
  const ref = useRef(null);
  const [cachedUrl, setCachedUrl] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const resp = await axios.get(url, { responseType: 'arraybuffer' });
        ref.current = URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
        setCachedUrl(ref.current);
      } catch (error) {
        console.error('Unable to load pdf.');
      }
    })();
    return () => {
      if (ref.current) {
        try {
          URL.revokeObjectURL(ref.current);
        } catch (error) {
          console.warn('Failed to revoke url', ref.current);
        }
      }
    };
  }, [url]);

  return cachedUrl;
}

export default function PdfViewer(props) {
  const { pdf, width, height } = props;
  const cachedUrl = useCacheFile(pdf);

  if (cachedUrl) {
    return <embed type="application/pdf" src={`${cachedUrl}#toolbar=0`} style={{ width, height }} />;
  }
  return (
    <div style={{ width, height }}>
      <CircularProgress />
    </div>
  );
}
